// extracted by mini-css-extract-plugin
export default {"container":"styles_container__sE3-y","selection":"styles_selection__CPmj+"};